import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { numberWithCommas } from "../../utils";
import DailyExpenseStatusChip from "./DailyExpenseStatusChip";
import {
  DAILY_EXPENSE_MENU_TITLE,
  dailyExpenseDayPath,
  dailyExpenseMonthPath,
} from "./constants";
import { DailyExpenseChipKind } from "./dailyExpenseStatus";
import { NeighbourDates } from "./dailyExpenseMonth";
import { formatDayTitle } from "./format";

interface DayHeaderProps {
  businessDate: string;
  month: string;
  /** Absent while the day is still loading. */
  summary: { branchCode: string; routeCount: number; chipKind: DailyExpenseChipKind } | null;
  neighbours: NeighbourDates;
}

/**
 * ‹ ค่าใช้จ่ายรายวัน, the day, its branch and status, and ‹ วันก่อน / วันถัดไป ›. All three are
 * links, so the unsaved-changes guard catches them like any other in-app link.
 */
export default function DayHeader({
  businessDate,
  month,
  summary,
  neighbours,
}: Readonly<DayHeaderProps>) {
  return (
    <Stack gap={0.5}>
      <Button
        component={Link}
        to={dailyExpenseMonthPath(month)}
        sx={{ alignSelf: "flex-start", px: 0 }}
      >
        ‹ {DAILY_EXPENSE_MENU_TITLE}
      </Button>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} flexWrap="wrap">
        <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
          <Typography variant="h6" fontWeight={600}>
            {formatDayTitle(businessDate)}
          </Typography>
          {summary && (
            <>
              <Typography variant="body2" color="text.secondary">
                สาขา {summary.branchCode} · {numberWithCommas(summary.routeCount)} สาย
              </Typography>
              <DailyExpenseStatusChip kind={summary.chipKind} />
            </>
          )}
        </Stack>
        <Stack direction="row" gap={1}>
          <Button
            variant="outlined"
            color="inherit"
            component={Link}
            to={neighbours.previous ? dailyExpenseDayPath(neighbours.previous) : ""}
            disabled={!neighbours.previous}
          >
            ‹ วันก่อน
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            component={Link}
            to={neighbours.next ? dailyExpenseDayPath(neighbours.next) : ""}
            disabled={!neighbours.next}
          >
            วันถัดไป ›
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
